'use client'

import { useScrollState } from '@/shared/lib'

type Props = {
  children: React.ReactNode
}

export const MobileContentWrapper = ({ children }: Props) => {
  const { ref } = useScrollState()

  return (
    <main ref={ref} className="flex h-0 grow flex-col overflow-y-auto">
      <div className="@container mx-auto w-full max-w-[700px]">{children}</div>
    </main>
  )
}
